<template>
  <v-dialog
    v-model="valueProxy"
    width="60%"
    :max-width="maxWidth"
    @create="reload"
    @update="reload"
    @delete="reload"
  >
    <v-card>
      <v-card-title class="primaryDialogTitle">
        <span class="headline">{{ title }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="valueProxy = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <ProfileEditForm
        :key="editFormKey"
        :profile="profile"
        @create="create"
        @update="update"
        :is-submitting="isSubmitting"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api';
import ApiError from '@/api/ApiError';
import editDialogMixin from '@/services/editDialogMixin';
import ProfileEditForm from '@/components/Identity/ProfileEditForm.vue';
import { createUserWithProfile } from '@/api/profile';

export default {
  name: 'IdentityEditDialog',
  components: {
    ProfileEditForm,
  },
  mixins: [editDialogMixin],
  props: {
    maxWidth: {
      type: String,
      default: '100vw',
    },
    roleList: {
      type: Array,
      default: () => [],
    },
    role: {
      type: String,
      default: 'hw.client',
    },
  },
  data() {
    return {
      profile: {
        role: this.role,
      },
      isSubmitting: false,
      editFormKey: 0,
    };
  },
  computed: {
    crudURL() {
      return `Profiles${this.id ? '/' + this.id : ''}`;
    },
    title() {
      switch (this.role) {
        case 'hw.client':
          return 'Create Client Profile';
          break;
        case 'hw.cashier':
          return 'Create Cashier Profile';
          break;
        case 'admin':
          return 'Create Admin Profile';
          break;
        default:
          return 'Create Profile';
      }
    },
  },
  watch: {
    valueProxy(v) {
      if (v) {
        this.editFormKey++;
      }
    },
  },
  async mounted() {
    await this.reload();
  },
  methods: {
    async reload() {
      this.model = {};
      this.profile = {
        role: this.role,
        isAllowPostQuotationInWeb: true,
        enabled: true,
      };
    },
    handleError(err) {
      const ae = ApiError.wrap(err);
      this.$store.dispatch('alert/updateAlertMessage', {
        msg: ae.message,
      });
    },
    update() {
      this.reload;
      this.$emit('update');
    },
    async create(v) {
      this.isSubmitting = true;
      try {
        await createUserWithProfile(api, v);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Created',
          type: 'success',
          color: 'success',
        });
        await this.reload;
        this.$emit('update');
      } catch (err) {
        this.handleError(err);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
